import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { AdSense } from '../components/AdSense';

export function SignupPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validation
    if (!formData.firstName.trim()) {
      setError('First name is required');
      setLoading(false);
      return;
    }

    if (!formData.lastName.trim()) {
      setError('Last name is required');
      setLoading(false);
      return;
    }

    if (!formData.email.includes('@')) {
      setError('Valid email is required');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      setLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      console.log('📝 SIGNUP SUBMIT:', { 
        firstName: formData.firstName, 
        lastName: formData.lastName,
        email: formData.email 
      });

      const response = await fetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          password: formData.password,
        }),
      });

      const data = await response.json();
      console.log('📥 Response from server:', {
        status: response.status,
        ok: response.ok,
        success: data.success,
        message: data.message,
      });

      if (!response.ok) {
        console.log('❌ Signup failed:', data.message);
        setError(data.message || 'Signup failed');
        setLoading(false);
        return;
      }

      // Save session to localStorage
      if (data.user) {
        console.log('💾 Saving session to localStorage...');
        localStorage.setItem('session_token', data.user.sessionToken);
        localStorage.setItem('app_session_token', data.user.sessionToken);
        localStorage.setItem('user_role', data.user.role);
        localStorage.setItem('user_email', data.user.email);
        localStorage.setItem('user_id', data.user.id);

        console.log('✅ Account created and logged in!');

        // Redirect to user dashboard
        navigate('/user-dashboard', { replace: true });
      }
    } catch (err) {
      console.error('❌ Network error:', err);
      setError('Connection error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-6 col-sm-8">
            <div className="card shadow border-0 rounded-lg">
              <div className="card-body p-4">
                <h2 className="card-title text-center mb-4 fw-bold">Create Account</h2>

                {error && <div className="alert alert-danger mb-4">{error}</div>}

                <form onSubmit={handleSignup}>
                  <div className="mb-3">
                    <label htmlFor="firstName" className="form-label">First Name</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      className="form-control"
                      placeholder="Enter your first name"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      autoComplete="given-name"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="lastName" className="form-label">Last Name</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      className="form-control"
                      placeholder="Enter your last name"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      autoComplete="family-name"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      autoComplete="email"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      className="form-control"
                      placeholder="Enter a password (minimum 6 characters)"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      autoComplete="new-password"
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                    <input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      className="form-control"
                      placeholder="Confirm your password"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      autoComplete="new-password"
                    />
                  </div>

                  <button 
                    type="submit" 
                    className="btn btn-primary w-100 fw-bold"
                    disabled={loading}
                  >
                    {loading ? 'Creating Account...' : 'Create Account'}
                  </button>
                </form>

                <div className="text-center mt-4">
                  <p className="text-muted">Already have an account? <a href="/login" className="text-primary fw-bold">Login here</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AdSense />

      <Footer />
    </div>
  );
}

export default SignupPage;
